import { isErrorWithStatus } from '.';

export const isInvalidWorkspaceError = isErrorWithStatus( 400, 'invalid_workspace' );
